import {Pipe, PipeTransform} from '@angular/core';
import {SysDateFormat} from '@core/constant/system.constants';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  constructor() {
    super('en-US');
  }

  transform(value: any, args?: any): any {
    try {
      if (value == undefined || value == '')
        return "-"
      return super.transform(value, args ? args : SysDateFormat.DATE);
    } catch (e) {
      return "-"
    }
  }
}
